import React from "react"
import SuggestArrow from "../../assets/images/SuggestArrow.svg"

const RightArrowBend = () => {
  return <img src= {SuggestArrow}  alt = "suggest arrow"/>
}

export default RightArrowBend;

